'use client';
import { Provider, createStore } from 'jotai';
import type { PropsWithChildren } from 'react';
import { storyAtom } from '~/app/(default-layout)/s/[storyId]/_state/novel-render-atoms';
import type { StoryOverview } from '~/common/types/story-overview';

type Props = PropsWithChildren<{
  story: StoryOverview;
}>;

export const NovelScriptStateProvider = ({ story, children }: Props) => {
  const store = createStore();
  store.set(storyAtom, story);
  return <Provider store={store}>{children}</Provider>;
};
